var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMigrate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "migrate-icon-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(155, 170, 243, 1)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(123, 216, 192, 1)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.254 10.4699L9.88398 2.08789L11.817 2.60589L14.627 11.6409L19.888 13.0509C20.0783 13.1018 20.2567 13.1898 20.413 13.3097C20.5693 13.4296 20.7004 13.5791 20.7989 13.7497C20.8975 13.9202 20.9614 14.1085 20.9872 14.3038C21.0129 14.4991 20.9999 14.6976 20.949 14.8879C20.898 15.0782 20.8101 15.2566 20.6902 15.4129C20.5703 15.5692 20.4208 15.7003 20.2502 15.7988C20.0796 15.8974 19.8913 15.9613 19.696 15.9871C19.5007 16.0128 19.3023 15.9998 19.112 15.9489L4.13998 11.9369L4.91598 9.03889L5.15798 9.10389L6.07198 12.4539L3.44498 11.7509C3.22972 11.693 3.03998 11.5648 2.90591 11.3867C2.77184 11.2086 2.70112 10.9908 2.70498 10.7679L2.79498 5.36489L4.24398 5.75289L5.15798 9.10389L10.254 10.4699ZM3.99998 18.9999H20V20.9999H3.99998V18.9999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrate);
export default __webpack_public_path__ + "static/media/migrate.37fd53b140e22f71a972f88f5787b21c.svg";
export { ForwardRef as ReactComponent };